import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=81bbf20a"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81bbf20a')) {
      api.createRecord('81bbf20a', component.options)
    } else {
      api.reload('81bbf20a', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=81bbf20a", function () {
      api.rerender('81bbf20a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/containers/Page.vue"
export default component.exports